// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"b7624fb0","419":"dbd2dc5b","458":"970be3fc","774":"1e2b54fd","858":"9becb466","942":"2465eb01","968":"1bfbb388"}[chunkId] + ".chunk.js";
};